module.exports = __webpack_public_path__ + "img/slide9.64386529.png";